import util from '../../common/util'

export default {
    filterClients() {
        return (filters) => {
            return this.plannerLogin.clients.filter((client) => util.customFilter(filters, client))
        }
    },
}
